import {RootState} from '../../reducers';
import {VaultElement, VaultElementType} from './vaultElementSlice';

export const selectVaultElements = (state: RootState) =>
    state.project.vaultElement.items;

export const selectVaultElementQuantity =
    (type: VaultElementType, id: string | null) => (state: RootState): number =>
        selectVaultElements(state).find((el: VaultElement) => el.elementType === type && el.id == id)?.quantity ?? 0;

export const selectIncludeWireRopeLoops =
    (type: VaultElementType, id: string | null) => (state: RootState): boolean =>
        selectVaultElements(state).find(
            (el: VaultElement) => el.elementType === type && el.id == id
        )?.includeWireRopeLoops
        ?? false;
